import script from "./AuthLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLayout.vue?vue&type=script&setup=true&lang=js"

import "./AuthLayout.vue?vue&type=style&index=0&id=e789b698&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e789b698"]])

export default __exports__